import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter }  from 'react-router-dom';
import { setCurrentLocation, clearState, setApplicationId } from '../../actions/applicationAction';
import { changeCard } from '../../actions/cardAction';

class RouteRedirect extends Component {
  constructor(props) {
    super(props);

    // A list, in order, of all the possible routes
    this.routes = [
      "/",
      "/GetStarted",
      "/RatesFees",
      "/PersonalInfo/Name",
      "/PersonalInfo/Birthdate",
      "/PersonalInfo/Contact",
      "/PersonalInfo/Address",
      "/PersonalInfo/PreviousAddress",
      "/PersonalInfo/LivingSituation",
      "/Occupation",
      "/IncomeExpenses",
      "/IncomeExpenses/Finances", 
      "/AuthorizedUsers",
      "/AuthorizedUsers/Add",
      "/Bpi",
      "/Review", 
      "/Review/ConfirmIdentity",
      "/Submit", 
      "/WhatsNext"
    ];

  }
  componentDidMount() {
    // Set document title 
    this.setDocumentTitle(this.props.card.name);    
    
    // Page is accessed directly
    if(this.props.location.pathname !== "/Error" && this.props.location.pathname !== "/TimeOut" && this.props.location.pathname !== "/") {
      // Check if application is complete, or currentLocation is null
      // Redirect to first page
      if(this.props.application.applicationComplete || this.props.application === undefined || this.props.application.currentLocation === undefined) {        
        // Clear out state, start new application
        this.props.clearState();

        // If the card type is specified in the URL, do not redirect.
        if(this.props.location.pathname.startsWith('/Card')) {          
          this.props.setCurrentLocation('/');
        }
        // If it's not the root page, redirect to it.
        else if(this.props.location.pathname !== "/") {          
          this.props.history.replace('/');
        }
        else {          
          this.props.setCurrentLocation(this.props.location.pathname);
        }
      }
      // Check if verificationSent is true
      // Redirect to Submit page
      else if(this.props.application.verificationSent && !this.props.application.applicationComplete && this.props.location.pathname !== "/Submit") {
        this.props.history.replace('/Submit');
      }
      // Check if applicationSent is true
      // Redirect to ConfirmIdentity page
      else if(this.props.application.applicationSent && !this.props.application.verificationSent && !this.props.application.applicationComplete && this.props.location.pathname !== "/Review/ConfirmIdentity") {
        this.props.history.replace('/Review/ConfirmIdentity');
      }
      // Else if currentLocation is not null
      // Check if requested path is not ahead of currentLocation
      // If ahead, redirect to currentLocation
      else if(this.routes.findIndex(route => route === this.props.location.pathname) > this.routes.findIndex(route => route === this.props.application.currentLocation)) {        
        this.props.history.replace(this.props.application.currentLocation);
      }
      else {        
        if(this.routes.findIndex(route => route === this.props.location.pathname) > 0) {                    
          this.props.setCurrentLocation(this.props.location.pathname);
        }
        else if(this.props.location.pathname.startsWith('/Card')) {          
          this.props.setCurrentLocation('/');
        }
        else {          
          this.props.history.replace(this.props.application.currentLocation);
        }
      }
    } else {      
      // Error page, clear all state
      this.props.clearState();
      this.props.setCurrentLocation(this.props.location.pathname);
    }
  }
  componentDidUpdate(prevProps) {        
    if(prevProps.card !== this.props.card) {
      this.setDocumentTitle(this.props.card.name);
    }
    if(prevProps.location.pathname !== this.props.location.pathname) {    
      // Page is redirected to using router
      if(this.props.location.pathname !== "/TimeOut" &&  this.props.location.pathname !== "/WhatsNext" && this.props.location.pathname !== "/Error") {
        if(this.props.application.currentLocation === undefined  && this.props.location.pathname !== "/") {          
          this.props.history.replace('/');
        }
        else if(this.props.application.applicationComplete && this.props.location.pathname !== "/WhatsNext"){
          this.props.history.replace('/WhatsNext');
        }
        // Check if verificationSent is true
        // Redirect to Submit page
        else if(this.props.application.verificationSent && !this.props.application.applicationComplete && this.props.location.pathname !== "/Submit") {
          this.props.history.replace('/Submit');
        }
        // Check if applicationSent is true
        // Redirect to ConfirmIdentity page
        else if(this.props.application.applicationSent && !this.props.application.verificationSent && this.props.location.pathname !== "/Review/ConfirmIdentity") {
          this.props.history.replace('/Review/ConfirmIdentity');
        }
        // Save current location to redux store
        else {          
          this.props.setCurrentLocation(this.props.location.pathname);
        }
      }
      else {
        let visaApplicationId = this.props.application.visaApplicationId;
        let card = this.props.card;
        // Time Out, clear state
        this.props.clearState();
        // Temporarily set the visaApplicationID again
        this.props.setApplicationId(visaApplicationId);
        this.props.changeCard(card);
      }
    }
  }
  setDocumentTitle(name) {
    if(name !== undefined && name !== null && name !== "") {
      document.title = `${name} | Credit card application | Vancity Credit Union`; 
    }
  }
  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  application: state.application,
  card: state.card
});

const mapDispatchToProps = dispatch => ({
  setCurrentLocation: (currentLocation) => dispatch(setCurrentLocation(currentLocation)),
  clearState: () => dispatch(clearState()),
  setApplicationId: (visaApplicationId) => dispatch(setApplicationId(visaApplicationId)),
  changeCard: card => dispatch(changeCard(card))
});


export default withRouter(connect(mapStateToProps, mapDispatchToProps) (RouteRedirect));


// WEBPACK FOOTER //
// ./src/containers/RouteRedirect/RouteRedirect.js